import React, { Component } from 'react'
import ScrollToTop from '../../../components/ScrollToTop'
import MenuSider from '../../../components/MenuSider'
import { connect } from 'react-redux'
import IntlMessages from '../../../util/IntlMessages';
import { Collapse } from 'antd'
import axios from 'axios'
import { Constants } from '../../../Constants/Constants'

const Panel = Collapse.Panel;

class AboutUs extends Component {

    

    render() {
        return (
            <div>
                <ScrollToTop />
                <MenuSider title={<IntlMessages id="about_us.title" />}>
                    <div style={{ width: "100%", padding: "5px" }}>
                        <Collapse defaultActiveKey={['1', '2']}>
                            <Panel header="Icon" key="1" style={{ fontSize: "13px" }}>
                                icon made by freepik ,those-icons ,smartline ,
                                monkik,itim2101 ,eucalyp ,swifticons ,smashicons ,pixel-perfect ,
                                mynamepong from flaticon.
                            </Panel>
                            <Panel header="Version" key="2" style={{ fontSize: "13px" }}>
                            {Constants.APP_VERSION}
                            </Panel>
                        </Collapse>
                    </div>

                </MenuSider>
            </div>
        );
    }
}
const mapStatetoProps = (state) => {
    return {
        detail: state.detail,
        authen: state.authen,
        detailMyOb: state.detailMyOb,
    }
}
// const mapDispatchProps = (dispatch) => {
//     return {
//         set_MonthPicker: (value) => {
//             dispatch({
//                 type: "set_MonthPicker2",
//                 MonthPicker2: value
//             })
//         }
//     }
// }

export default connect(mapStatetoProps)(AboutUs)